// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2cBST","label":"Labeled_label__2CMRv","divider":"Labeled_divider__3zy2D"};